export default __webpack_public_path__ + "static/media/balance.367264f6.png";